import React from 'react';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';

function Terms() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>Terms and Conditions</Typography>
      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <Typography variant="caption" color="text.secondary" display="block" mb={3}>Last update: January 2025</Typography>
          
          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>1. Platform Access</Typography>
          <Typography paragraph>
            Access to the Platform is reserved exclusively to affiliates authorized by Digitoo. Autonomous registration is not permitted.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>2. Affiliate Obligations</Typography>
          <Typography paragraph>
            The Affiliate undertakes to use the Platform in compliance with current legislation, these Terms, and the signed privacy waiver.
          </Typography>
          <Typography paragraph>In particular, the Affiliate agrees to:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Not share access credentials with third parties</Typography></li>
            <li><Typography>Use the Platform only for authorized purposes</Typography></li>
            <li><Typography>Promptly report any security issues or unauthorized access</Typography></li>
            <li><Typography>Comply with all applicable laws and regulations</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>3. Data Processing</Typography>
          <Typography paragraph>
            The processing of personal data is governed by the Privacy Policy and the Additional Terms signed separately.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>4. Suspension and Termination</Typography>
          <Typography paragraph>
            Digitoo reserves the right to suspend or revoke access in case of violations, including but not limited to:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Breach of these Terms and Conditions</Typography></li>
            <li><Typography>Fraudulent activity or attempted fraud</Typography></li>
            <li><Typography>Unauthorized use of the Platform</Typography></li>
            <li><Typography>Violation of applicable laws</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>5. Limitation of Liability</Typography>
          <Typography paragraph>
            Digitoo is not liable for damages arising from non-compliant use of the Platform. The Platform is provided "as is" without warranties of any kind, express or implied.
          </Typography>
          <Typography paragraph>
            In no event shall Digitoo be liable for any indirect, incidental, special, consequential, or punitive damages.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>6. Intellectual Property</Typography>
          <Typography paragraph>
            All intellectual property rights related to the Platform, including but not limited to software, design, logos, and documentation, remain the exclusive property of Digitoo.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>7. Modifications</Typography>
          <Typography paragraph>
            Digitoo reserves the right to modify these Terms at any time. Users will be notified of significant changes through the Platform.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>8. Applicable Law and Jurisdiction</Typography>
          <Typography paragraph>
            These Terms are governed by Italian law. Exclusive jurisdiction: Court of Turin, Italy.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Terms;

